import { signature as commonSignature } from 'e-submission/domain/data-model/form/pages/signature'
import { signatureSection } from 'e-submission/domain/data-model/form/signatureSection'
import signatureDisclaimerSection from 'e-submission/domain/data-model/form/signatureDisclaimerSection'
import { compact } from 'lodash/fp'
import {
  havePayer,
  isSelectedRemoteSelling,
  isRemoteSelling,
  isNeedDocCRS,
  getSkippedInsuredEkyc,
  getSkippedPayerEkyc,
} from 'e-submission/domain/data-model/form/selectors'
import {
  isInsuredUseCitizenId,
  isInsuredUsePassport,
  isPayerUseCitizenId,
  isPayerUsePassport,
} from 'e-submission/apps/selectors'
import { getToggles } from 'quick-quote/feature-toggles'
import { haveThirdPerson } from 'e-submission/apps/selectors'

export const baseAgentRequiredDocs = [
  'BI',
  'APPLICATION',
  'E_POLICY_CONSENT',
  'ADDENDUM',
  'FOREIGNER',
  'FNA',
  'VULNERABLE_CUSTOMER',
]

export default (app) => {
  const isShowPayerPage = havePayer(app)
  const isHaveThirdPerson = haveThirdPerson(app)

  // For RMS v3
  const isInsuredSkippedEkyc = getSkippedInsuredEkyc(app)
  const isPayerSkippedEkyc = getSkippedPayerEkyc(app)

  const insuredRequiredDocs = [
    'BI',
    'APPLICATION',
    'E_POLICY_CONSENT',
    'PRIVACY_CONSENT',
    'PENSION_RECEIVE',
    'ADDENDUM',
    'FOREIGNER',
    'FNA',
    getToggles().ENABLE_CRS_SECTION && isNeedDocCRS(app, 'insured') && 'CRS',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'PASSPORT_CONSENT_INSURED',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'CITIZEN_ID_CONSENT_INSURED',
    // GIFT
    isSelectedRemoteSelling(app) && !isInsuredSkippedEkyc && 'CONFIRMATION_LETTER_INSURED',
  ]
  const payerRequiredDocs = [
    'APPLICATION',
    'E_POLICY_CONSENT',
    'PRIVACY_CONSENT',
    'ADDENDUM',
    'FNA',
    getToggles().ENABLE_CRS_SECTION && isNeedDocCRS(app, 'payer') && 'CRS',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'PASSPORT_CONSENT_PAYER',
    (getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && 'CITIZEN_ID_CONSENT_PAYER',
    // GIFT
    isSelectedRemoteSelling(app) && !isPayerSkippedEkyc && 'CONFIRMATION_LETTER_PAYER',
  ]
  let acknowledgeRequiredDocs = [
    'PRIVACY_POLICY',
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isInsuredUseCitizenId(app)
      ? 'CITIZEN_ID_CONSENT_INSURED'
      : undefined,
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isInsuredUsePassport(app) ? 'PASSPORT_CONSENT_INSURED' : undefined,
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isPayerUseCitizenId(app) ? 'CITIZEN_ID_CONSENT_PAYER' : undefined,
    getToggles().ENABLE_CITIZEN_ID_CONSENT_FORM && isPayerUsePassport(app) ? 'PASSPORT_CONSENT_PAYER' : undefined,
  ]

  if ((getToggles().ENABLE_EKYC_F2F || isSelectedRemoteSelling(app)) && !isRemoteSelling(app)) {
    acknowledgeRequiredDocs = acknowledgeRequiredDocs.filter((docs) => docs === 'PRIVACY_POLICY')
  }

  const insuredSignatureSection = signatureSection('insured', insuredRequiredDocs)

  const agentSignatureSection = signatureSection('agent', baseAgentRequiredDocs)

  const payerSignatureSection = signatureSection('payer', payerRequiredDocs)

  const acknowledgeSignatureSection = signatureSection('acknowledge', compact(acknowledgeRequiredDocs))

  const thirdPersonSignatureSection = signatureSection('thirdPerson', ['FNA'])

  return commonSignature(app, {
    sections: compact([
      insuredSignatureSection('insured', 'ลงนาม ผู้เอาประกันภัย'),
      isShowPayerPage && payerSignatureSection('payer', 'ลงนาม ผู้ชำระเบี้ย'),
      agentSignatureSection('agent', 'ลงนาม ตัวแทน/นายหน้าประกันชีวิต'),
      isHaveThirdPerson && thirdPersonSignatureSection('thirdPerson', 'ลงนาม บุคคลที่สาม'),
      getToggles().ENABLE_PDPA_CONSENT && acknowledgeSignatureSection('acknowledge', 'ตรวจทานเอกสาร'),
      signatureDisclaimerSection('disclaimer'),
    ]),
  })
}
